var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionSingleBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 37,
    viewBox: "0 0 52 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4067 24.1974C33.0988 31.5492 26.231 36.8823 18.1177 36.8823C8.11155 36.8823 0 28.7707 0 18.7646C0 8.75852 8.11155 0.646973 18.1177 0.646973C25.7993 0.646973 32.3644 5.42756 35 12.1759V11.5224L51.0588 17.9412L35.4067 24.1974Z",
    fill: "#00A8A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.22 7.79C19.56 7.79 20.75 8.04 21.79 8.54C22.83 9.04 23.64 9.76 24.22 10.7C24.8 11.64 25.09 12.78 25.09 14.12C25.09 15.48 24.79 16.61 24.19 17.51C23.59 18.39 22.77 19.05 21.73 19.49C20.69 19.93 19.51 20.16 18.19 20.18L18.04 22.49H14.5L14.35 17.45H15.64C16.42 17.45 17.14 17.41 17.8 17.33C18.46 17.23 19.02 17.06 19.48 16.82C19.96 16.58 20.33 16.24 20.59 15.8C20.85 15.36 20.98 14.79 20.98 14.09C20.98 13.49 20.87 12.98 20.65 12.56C20.43 12.14 20.11 11.82 19.69 11.6C19.29 11.36 18.78 11.24 18.16 11.24C17.24 11.24 16.51 11.49 15.97 11.99C15.45 12.47 15.19 13.17 15.19 14.09H11.35C11.33 12.87 11.59 11.79 12.13 10.85C12.67 9.91 13.45 9.17 14.47 8.63C15.51 8.07 16.76 7.79 18.22 7.79ZM16.39 29.21C15.65 29.21 15.04 28.98 14.56 28.52C14.1 28.06 13.87 27.49 13.87 26.81C13.87 26.13 14.1 25.56 14.56 25.1C15.04 24.62 15.65 24.38 16.39 24.38C17.11 24.38 17.7 24.62 18.16 25.1C18.64 25.56 18.88 26.13 18.88 26.81C18.88 27.49 18.64 28.06 18.16 28.52C17.7 28.98 17.11 29.21 16.39 29.21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionSingleBubble);
export default __webpack_public_path__ + "static/media/question-single-bubble.4e330e465cf0339b5bb1aa6841beed8a.svg";
export { ForwardRef as ReactComponent };